import type { ToolDefinition } from "@arcadeai/arcadejs/resources/index.mjs";
import type { ToolkitCollection } from "@arcadeai/ui-kit/arcade/arcade";
import { buildToolkitCollection } from "@arcadeai/ui-kit/arcade/toolkit-collection";
import { filterHiddenToolkits } from "@arcadeai/ui-kit/utils/filter-hidden-toolkits";
import { queryOptions } from "@tanstack/react-query";
import { getAllEnginePages, getEngineApi } from "@/lib/api";
import { HIDDEN_TOOLKITS } from "@/lib/const";
import type { OrgProjectScope } from "@/lib/resource-context";
import { toolkitCollectionQueryKey } from "./toolkit-collection-key";

const selectFilteredToolkits = (data: ToolkitCollection) =>
  filterHiddenToolkits(data, HIDDEN_TOOLKITS);

export const toolkitCollectionQueryOptions = (scope: OrgProjectScope) =>
  queryOptions<ToolkitCollection>({
    queryKey: toolkitCollectionQueryKey(scope),
    queryFn: async () => {
      const client = getEngineApi(scope);
      const data = await getAllEnginePages<ToolDefinition>(client, "/tools");
      return buildToolkitCollection(data.items);
    },
    select: selectFilteredToolkits,
  });
